// extracted by mini-css-extract-plugin
module.exports = {"root":"_1gL43","bg":"_2lMfK"};